module.exports = __webpack_public_path__ + "img/linkedin-logo-white.b251da97.svg";